import React from "react";
import { PROFILE } from "../lib/content";
import { useContactModal } from "../lib/contactModal";

const CollaborationBand = () => {
  const { openModal } = useContactModal();
  return (
  <section
    id="collaborate"
    data-testid="section-collaborate"
    className="relative py-16 sm:py-20 bg-alabaster overflow-hidden"
  >
    <div className="max-w-7xl mx-auto px-6 sm:px-10 reveal">
      <div className="relative bg-white border border-alabaster-line rounded-3xl p-8 sm:p-12 grid grid-cols-1 lg:grid-cols-12 gap-8 items-center overflow-hidden">
        <div
          className="absolute -top-20 -right-20 w-72 h-72 rounded-full pointer-events-none"
          style={{ background: "radial-gradient(circle, rgba(245,187,31,0.18), transparent 60%)" }}
          aria-hidden
        />
        <div
          className="absolute -bottom-24 -left-24 w-72 h-72 rounded-full pointer-events-none"
          style={{ background: "radial-gradient(circle, rgba(40,74,59,0.15), transparent 60%)" }}
          aria-hidden
        />

        <div className="lg:col-span-3 flex justify-center lg:justify-start">
          <div className="relative">
            <img
              src={PROFILE.portraitSuit}
              alt="Yazid"
              className="w-44 h-44 sm:w-52 sm:h-52 rounded-3xl object-cover"
            />
            <div className="absolute -top-3 -right-3 bg-emerald2 text-alabaster text-[10px] font-display font-bold tracking-widest uppercase rounded-full px-3 py-1 shadow-lg">
              Won 1st Place
            </div>
          </div>
        </div>

        <div className="lg:col-span-9">
          <div className="eyebrow inline-flex items-center gap-3">
            <span className="block w-10 h-px bg-terracotta" />
            Open to Collaboration
          </div>
          <h3
            data-testid="collaborate-heading"
            className="font-display mt-3 text-3xl sm:text-4xl lg:text-5xl font-bold text-ink leading-[1.08] tracking-tight"
          >
            Got a dream worth chasing? <br />
            <span className="text-terracotta">Let's make it real.</span>
          </h3>
          <p className="mt-5 text-ink-soft text-base sm:text-lg max-w-2xl leading-relaxed">
            Whether you're an <span className="text-ink font-semibold">educator</span>, <span className="text-ink font-semibold">student</span>, <span className="text-ink font-semibold">young innovator</span> or <span className="text-ink font-semibold">future change-maker</span> — if you want to <HL>achieve a goal</HL>, <HL>win a contest</HL>, <HL>drive a change</HL> or <HL>create real impact</HL>, let's join forces and turn your vision into something the world will remember.
          </p>
          <button
            data-testid="collaborate-cta-contact"
            onClick={openModal}
            className="btn-primary mt-8"
          >
            Let's Join Forces
          </button>
        </div>
      </div>
    </div>
  </section>
  );
};

const HL = ({ children }) => (
  <span className="text-terracotta font-semibold">{children}</span>
);

export default CollaborationBand;
